import { useState, useCallback } from 'react';
import { POI_TYPES } from '../../../../../constants/poiTypes';
import { logInfo } from '../../../../../utils/logger';

export const useVisibilityState = (settings) => {
  const [visibilityState, setVisibilityState] = useState(() => ({
    poiTypes: Object.keys(POI_TYPES).reduce((acc, type) => ({
      ...acc,
      [type]: true
    }), {}),
    routes: {},
    routePlanner: false,
    showTraffic: settings?.preferences?.mapSettings?.showTraffic || false,
    showStreetView: settings?.preferences?.mapSettings?.showStreetView || false,
    showWeather: settings?.preferences?.mapSettings?.showWeather || false,
    showTeamMembers: settings?.preferences?.mapSettings?.showTeamMembers || false,
    showCompass: settings?.preferences?.mapSettings?.showCompass || false,
    showScaleBar: settings?.preferences?.mapSettings?.showScaleBar || false,
    showToolbar: settings?.preferences?.mapSettings?.showToolbar || true,
    showPOILabels: settings?.preferences?.mapSettings?.showPOILabels || true,
    showPOIInfo: settings?.preferences?.mapSettings?.showPOIInfo || true,
    showPOIMeasurements: settings?.preferences?.mapSettings?.showPOIMeasurements || true,
    showRouteNames: settings?.preferences?.mapSettings?.showRouteNames || true,
    showDistanceMarkers: settings?.preferences?.mapSettings?.showDistanceMarkers || true,
    showRouteDirections: settings?.preferences?.mapSettings?.showRouteDirections || false,
    clusterPOIs: settings?.preferences?.mapSettings?.clusterPOIs || true
  }));

  const handleVisibilityToggle = useCallback((type, visible) => {
    if (type === 'poiTypes') {
      setVisibilityState(prev => ({
        ...prev,
        poiTypes: visible
      }));
      logInfo('POI types visibility updated');
      return;
    }

    if (type === 'route') {
      const { id, visible: newVisibility } = visible;
      setVisibilityState(prev => ({
        ...prev,
        routes: {
          ...prev.routes,
          [id]: newVisibility
        }
      }));
      logInfo(`Route visibility toggled: ${id} - ${newVisibility}`);
      return;
    }

    if (Object.keys(POI_TYPES).includes(type)) {
      setVisibilityState(prev => ({
        ...prev,
        poiTypes: {
          ...prev.poiTypes,
          [type]: visible
        }
      }));
      logInfo(`POI type visibility toggled: ${type} - ${visible}`);
      return;
    }

    setVisibilityState(prev => ({
      ...prev,
      [type]: visible
    }));
    logInfo(`Visibility toggled for ${type}: ${visible}`);
  }, []);

  return {
    visibilityState,
    handleVisibilityToggle
  };
};